export const siteLang = () => {
  try {
    if (localStorage.getItem("ts_lang") === "sv") return "sv";
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/sv")) return "sv";
  } catch { /* noop */ }
  return "en";
};
